import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { CalculateIcon, DepthIcon } from '@icons/index';
import { withLogin } from '@hoc/withLogin';
import { Lnb } from '../../common/lnb';

export const Billing = withLogin(() => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Container>
      <Lnb
        menuItem={[
          {
            name: t('Billing_Menu.Cost'),
            icon: <CalculateIcon width={20} height={20} />,
            subMenu: [
              {
                name: t('Billing_Menu.Diagnosis'),
                icon: <DepthIcon width={16} height={16} color={theme.colors['ic-gray-main']} />,
                selectedIcon: <DepthIcon width={16} height={16} color={theme.colors['ic-primary-light']} />,
                to: 'cost',
              },
              {
                name: t('Billing_Menu.Status_Inquiry'),
                icon: <DepthIcon width={16} height={16} color={theme.colors['ic-gray-main']} />,
                selectedIcon: <DepthIcon width={16} height={16} color={theme.colors['ic-primary-light']} />,
                to: 'dashboard',
              },
              {
                name: t('Billing_Menu.Billing_History_Inquiry'),
                icon: <DepthIcon width={16} height={16} color={theme.colors['ic-gray-main']} />,
                selectedIcon: <DepthIcon width={16} height={16} color={theme.colors['ic-primary-light']} />,
                to: 'history',
              },
            ],
          },
        ]}
      />
      <Outlet />
    </Container>
  );
});

const Container = styled('div')`
  width: 100%;
  display: flex;
`;
